import { describeFields, FieldWidget } from '../common/fields';
import { TUTORIAL_LOCATIONS } from './constants';
import { TutorialSchema } from './schemas';

export const TUTORIAL_FIELDS = describeFields(TutorialSchema, {
  courseId: {},
  duration: {},
  hostId: { widget: FieldWidget.Select, displayField: 'hostName' },
  description: {},
  joinLink: {},
  location: { options: TUTORIAL_LOCATIONS.map(location => ({ value: location, label: location })) },
  capacity: {},
  attendees: {},
  linkedTutorialIds: {},
});
